import { ref } from 'vue'

const snackbar = ref({
  open: false,
  message: null,
  color: null
})

export const useSnackbar = () => {
  const openSnackbar = ({ message, color }) => {
    snackbar.value.open = true
    snackbar.value.message = message
    snackbar.value.color = color
  }

  return {
    snackbar,
    openSnackbar
  }
}
